import React from 'react';
import {
  BANNER_MOBILE_IMAGE_MAX_BYTES,
  BANNER_PC_IMAGE_MAX_BYTES,
  BANNER_VIDEO_MAX_BYTES,
  formatKb,
  formatMb,
} from './FileProcessingUtils';

interface DropzoneContentProps {
  title: string;
}

const DropzoneContent: React.FC<DropzoneContentProps> = ({ title }) => (
  <div>
    <h5 className="mb-3 fw-bold text-primary">{title}</h5>
    <small className="text-muted d-block">
      Supported formats: WebP — PC banner max {formatKb(BANNER_PC_IMAGE_MAX_BYTES)} / Mobile banner max{' '}
      {formatKb(BANNER_MOBILE_IMAGE_MAX_BYTES)} · MP4 max {formatMb(BANNER_VIDEO_MAX_BYTES)}
    </small>
    <p className="mt-2">
      <span className="badge bg-info">Tip: Drop all image/video sizes at once!</span>
    </p>
  </div>
);

export default DropzoneContent;
